import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["childDropdown", "theme"],
    _excluded2 = ["targetContent", "dropdownContent"],
    _excluded3 = ["children"],
    _excluded4 = ["mini", "children", "childDropdown", "theme"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { DropdownMenu } from '../Popover';
import MenuList from '../MenuList';
import Box from '../Box';
import Text from '../Text';
import BaseHR from '../HR';
import Profile from '../Icons/ProfileIcon';
import DownIcon from '../Icons/DownIcon';
import CloseThinIcon from '../Icons/CloseThinIcon';
import { MiniLink, MiniOverlay } from './MiniOverlay';
import { isFunction } from '../utils';

var isHRElement = function isHRElement(ele) {
  return ele && ele.type && ele.type.displayName === 'MenuHR';
};

var UserIcon = withTheme(function (_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/React.createElement(Profile, {
    width: theme.topHeader.iconSize,
    height: theme.topHeader.iconSize
  });
});
var UserMiniDropdown = withTheme(function (_ref2) {
  var theme = _ref2.theme,
      hideOverlay = _ref2.hideOverlay,
      children = _ref2.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    pt: theme.topHeader.marginX,
    textAlign: "right",
    color: "navLabel",
    onClick: hideOverlay,
    cursor: "pointer"
  }, /*#__PURE__*/React.createElement(CloseThinIcon, {
    width: theme.topHeader.iconSize,
    height: theme.topHeader.iconSize
  })), /*#__PURE__*/React.createElement("ul", {
    role: "navigation"
  }, React.Children.toArray(children).map(function (link) {
    return /*#__PURE__*/React.createElement(Box, {
      as: "li",
      key: link.key,
      display: "flex",
      alignItems: "center"
    }, isHRElement(link) ? /*#__PURE__*/React.cloneElement(link, {
      width: '100%'
    }) : /*#__PURE__*/React.createElement(MiniLink, _extends({}, link.props, {
      onClick: function onClick(e) {
        hideOverlay(e);

        if (isFunction(link.props.onClick)) {
          link.props.onClick(e);
        }
      }
    })));
  })));
});

var _ref4 = /*#__PURE__*/React.createElement(UserIcon, null);

export var MiniUser = withTheme(function (_ref3) {
  var childDropdown = _ref3.childDropdown,
      theme = _ref3.theme,
      props = _objectWithoutProperties(_ref3, _excluded);

  return childDropdown ? /*#__PURE__*/React.createElement(MiniOverlay, _extends({
    zIndex: 3,
    controlButton: _ref4
  }, props, {
    overlayContent: /*#__PURE__*/React.createElement(UserMiniDropdown, null, React.Children.toArray(childDropdown.props.children))
  })) : /*#__PURE__*/React.createElement(Box, _extends({
    ml: theme.topHeader.marginX,
    textAlign: "right"
  }, props), /*#__PURE__*/React.createElement(Profile, {
    width: theme.topHeader.iconSize,
    height: theme.topHeader.iconSize
  }));
});

var _ref8 = /*#__PURE__*/React.createElement(Box, {
  ml: "5px"
}, /*#__PURE__*/React.createElement(DownIcon, {
  width: "8px",
  height: "8px"
}));

var UserDropdown = function UserDropdown(_ref5) {
  var targetContent = _ref5.targetContent,
      dropdownContent = _ref5.dropdownContent,
      props = _objectWithoutProperties(_ref5, _excluded2);

  var _ref7 = /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column"
  }, targetContent);

  return /*#__PURE__*/React.createElement(DropdownMenu, _extends({}, props, {
    target: function target(_ref6) {
      var targetProps = _ref6.targetProps;
      return /*#__PURE__*/React.createElement(Box, _extends({
        display: "flex",
        cursor: "pointer",
        tabIndex: "0"
      }, targetProps), _ref7, _ref8);
    }
  }), function (props) {
    return /*#__PURE__*/React.cloneElement(dropdownContent, props);
  });
};

export var UserMenu = /*#__PURE__*/React.forwardRef(function (_ref9, forwardRef) {
  var children = _ref9.children,
      props = _objectWithoutProperties(_ref9, _excluded3);

  return /*#__PURE__*/React.createElement(MenuList, _extends({}, props, {
    textAlign: "left",
    ref: forwardRef
  }), React.Children.toArray(children).map(function (child, index) {
    return isHRElement(child) ? /*#__PURE__*/React.createElement(MenuList.HR, {
      key: index
    }) : /*#__PURE__*/React.createElement(MenuList.Item, _extends({
      as: child.props.href ? 'a' : 'div',
      key: index,
      px: "30px"
    }, child.props));
  }));
});
UserMenu.Item = Text;
UserMenu.HR = BaseHR;
UserMenu.HR.displayName = 'MenuHR';
export var User = withTheme(function (_ref10) {
  var mini = _ref10.mini,
      children = _ref10.children,
      childDropdown = _ref10.childDropdown,
      theme = _ref10.theme,
      props = _objectWithoutProperties(_ref10, _excluded4);

  return mini ? /*#__PURE__*/React.createElement(MiniUser, _extends({
    childDropdown: childDropdown
  }, props)) : /*#__PURE__*/React.createElement(Text, _extends({
    as: "div",
    ml: theme.topHeader.marginX,
    textStyle: theme.topHeader.userTextStyle,
    color: theme.topHeader.color,
    textAlign: "right"
  }, props), childDropdown ? /*#__PURE__*/React.createElement(UserDropdown, {
    targetContent: children,
    dropdownContent: childDropdown
  }) : children);
});
process.env.NODE_ENV !== "production" ? User.propTypes = _objectSpread({
  mini: PropTypes.bool
}, Box.propTypes) : void 0;